module.exports = __webpack_public_path__ + "static/img/dubai.a1c947c7.png";